import React, {useEffect, useState} from "react";
import {ConfirmModal, useNotifications} from "peggirkit";
import {SetStateFn} from "@/utils/SetStateUtils";
import {FormattedMessage, useIntl} from "react-intl";
import {notifyDanger, notifySuccess} from "@/utils/NotifyUtils";
import {globalConfirmModalProps} from "@/utils/ModalUtils";
import {api} from "@/data/api";

type Props = {
    show: boolean,
    setShow: SetStateFn<boolean>,
    setLogsLastUpdated: SetStateFn<Date>,
};

const DeleteLogs = ({show, setShow, setLogsLastUpdated}: Props) => {
    const intl = useIntl();
    const {notify} = useNotifications();
    const [loading, setLoading] = useState(false);

    // Delete logs
    useEffect(() => {
        if (!loading)
            return;

        api.sync.deleteSynchronizationLogs()
            .then(() => {
                setLogsLastUpdated(new Date());
                notifySuccess(intl.formatMessage({id: "syncLogsDeleted"}), notify);
                setShow(false);
                setLoading(false);
            })
            .catch((e) => {
                console.log(e);
                setLoading(false);
                notifyDanger(intl.formatMessage({id: "systemError"}), notify);
            });
    }, [loading, setLoading, setShow, intl, notify, setLogsLastUpdated]);

    return (
        <ConfirmModal
            {...globalConfirmModalProps(intl)}
            show={show}
            onClose={() => setShow(false)}
            title={intl.formatMessage({id: "confirmSyncLogsDeletion"})}
            type={"warning"}
            continueButton={{
                text: intl.formatMessage({id: "continue"}),
                onClick: () => setLoading(true),
            }}
            loading={loading}
        >
            <FormattedMessage id={"confirmSyncLogsDeletion.description"}/>
        </ConfirmModal>
    );
};

export default DeleteLogs;